<script setup lang="ts">
definePageMeta({
  layout: 'customer-service-layout',
})
const { pageContent } = await useLegalArea('help-area-pages')
</script>

<template>
  <CustomerService v-if="pageContent?.content" :content="pageContent.content" />
</template>
